const envDev = process.env.NODE_ENV === 'development' || false

export const config = {
  env: process.env.NODE_ENV || 'development',
  API_URL: envDev ? 'http://localhost:3333/' : 'https://api.treinacodigo.com.br/'
}
